import { ref as a } from "vue";
const e = a([]);
let u = 0;
function p() {
  const t = (o, s = "info", n = 3e3) => {
    const r = ++u, i = {
      id: r,
      message: o,
      variant: s,
      visible: !0
    };
    return e.value.push(i), n > 0 && setTimeout(() => {
      c(r);
    }, n), r;
  }, c = (o) => {
    const s = e.value.findIndex((n) => n.id === o);
    s > -1 && e.value.splice(s, 1);
  };
  return {
    toasts: e,
    addToast: t,
    removeToast: c,
    success: (o, s) => t(o, "success", s),
    error: (o, s) => t(o, "error", s),
    warning: (o, s) => t(o, "warning", s),
    info: (o, s) => t(o, "info", s)
  };
}
export {
  p as useToast
};
